import { observable, action } from "mobx";

class BaseFilterModel {
    @observable value;

    constructor(definition) {
        this.definition = definition;
        this.value = definition.defaultValue || "";
    }

    @action
    updateValue(newValue) {
        this.value = newValue;
    }

    get key() {
        return "";
    }

    get func() {
        return rowData => true;
    }

    get type() {
        return this.definition.type;
    }

    get className() {
        return this.definition.className;
    }

    get columnName() {
        return this.definition.columnSourceName;
    }

    get defaultValue() {
        return this.definition.defaultValue;
    }

    get isNoOp() {
        return this.definition.noopFilter;
    }

    get placeholder() {
        return this.definition.placeholder;
    }
}

export default BaseFilterModel;
